export default __webpack_public_path__ + "static/media/reports-requested.028ce3c5.svg";